import { render, staticRenderFns } from "./SocialShareButtons.vue?vue&type=template&id=21c4460a&scoped=true&"
import script from "./SocialShareButtons.vue?vue&type=script&lang=ts&"
export * from "./SocialShareButtons.vue?vue&type=script&lang=ts&"
import style0 from "./SocialShareButtons.vue?vue&type=style&index=0&id=21c4460a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c4460a",
  null
  
)

export default component.exports